import { UseFormReturn } from "react-hook-form";
import { useState } from "react";
import { Step } from "./constants";
import { CaretLeft } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { DrawerHeader } from "@/components/ui/drawer";
import { useTranslation } from "react-i18next";
import { ExecutionEntryFormValues } from "./index";

const RunningHoursStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<ExecutionEntryFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const [hours, setHours] = useState(
    form.getValues("runningHoursAtExecution")?.toString() ?? ""
  );

  return (
    <div>
      <DrawerHeader
        title={t("label.running_hours")}
        leftButton={
          <button type="button" onClick={() => setStep(Step.INITIAL)}>
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-[18px]" />}
      />

      <Input
        data-testid="execution-entry-form-running-hours-input"
        type="number"
        placeholder={t("label.running_hours")}
        severity="light"
        className="h-[50px] rounded-lg"
        size="sm"
        value={hours}
        onChange={(e) => setHours(e.target.value)}
      />

      <Button
        data-testid="execution-entry-form-running-hours-submit-button"
        className="mt-4 w-full"
        onClick={() => {
          const hoursValue = hours === "" ? undefined : Number(hours);
          form.setValue("runningHoursAtExecution", hoursValue as number);
          form.trigger("runningHoursAtExecution");
          if (hoursValue !== undefined) {
            setStep(Step.INITIAL);
          }
        }}
      >
        {t("button.add")}
      </Button>
    </div>
  );
};

export default RunningHoursStep;
